import i18nHelper from '../../../core/services/i18n.service';
import http from "../../../core/services/http.service";
import {Formatter} from "@/core/services/formatter.service";
import {AppSettings} from "@/shared/AppSettings";

function getDepartments(params = null) {
  return http.get('/api/v1/departments/', {params});
}

function getDepartment(id,params = null) {
  return http.get(`/api/v1/departments/${id}/`, {params});
}

function updateDepartment(id, formData, onUploadProgress, expand = '') {
  return http.put(AppSettings.getUrl(`/api/v1/departments/${id}/?expand=${expand}`), formData, {
    headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress});
}

function createDepartment(formData, onUploadProgress, expand = '') {
  return http.post(AppSettings.getUrl(`/api/v1/departments/?expand=${expand}`), formData, {
    headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress});
}

function removeDepartment(uuid) {
  return http.delete(`/api/v1/departments/${uuid}`)
}

function getGeneralFields() {
  return {
    translatableFields: [
      {
        name: 'name'
      },
    ],
  }
}

function getDepartmentsForDropdown() {
  return new Promise(async (resolve) => {
    const departments = (await getDepartments({
      expand: 'categories'
    })).body;
    const returnArr = [];

    departments.forEach((department) => {
      returnArr.push({
        key: Formatter.getByMasterLanguage(department.name),
        value: department.uuid
      })
    });

    resolve(returnArr);
  })
}

function postDepartmentsOnWebsite() {
  return http.post(`/api/v1/departments/website-sync/`);
}

export default {
  getDepartments,
  getDepartment,
  updateDepartment,
  createDepartment,
  removeDepartment,
  getGeneralFields,
  getDepartmentsForDropdown,
  postDepartmentsOnWebsite
};
